import { PatientTimeslotPreferenceChipsStack } from '@/components/patients/PatientTimeslotPreferenceChip';
import { HorizontalStack, VerticalStack } from '@/components/utils/linearLayouts';
import { DialogType, useDialog } from '@/dialogs/DialogManager';
import { WeekdayTimeWindow } from '@/utils/datetimes/weekdays';

import { HeadingCaptionLabel, LeftRailNoneLabel, LeftRailTextButton } from './PatientLeftRail';

export function PatientLeftRailAvailabilitySection({
    patient,
}: {
    patient: {
        id: string;
        permissions: {
            editAvailability: boolean;
        };
        preferredTimeslots: WeekdayTimeWindow[];
    };
}) {
    const { openDialog } = useDialog();

    return (
        <VerticalStack spacing={1}>
            <HorizontalStack justifyContent='space-between'>
                <HeadingCaptionLabel>Preferred Availability</HeadingCaptionLabel>
                {patient.permissions.editAvailability && (
                    <LeftRailTextButton
                        onClick={() =>
                            openDialog(DialogType.EditPatientTimeslotPreferences, {
                                patientId: patient.id,
                            })
                        }
                    >
                        Edit
                    </LeftRailTextButton>
                )}
            </HorizontalStack>
            {patient.preferredTimeslots.length > 0 ? (
                <PatientTimeslotPreferenceChipsStack
                    patientTimeslotPreferences={patient.preferredTimeslots}
                />
            ) : (
                <LeftRailNoneLabel />
            )}
        </VerticalStack>
    );
}
